module.exports = __webpack_public_path__ + "static/media/Branch.3dbbf415.svg";